export function filterFieldsByKeys({ fields, ...rest }, selected = []) {
  return {
    ...rest,
    fields: selected.reduce((acc, key) => {
      if (fields[key]) {
        acc[key] = fields[key];
      }
      return acc;
    }, {}),
  };
}
